<template>
  <RawRecords v-if="showRawOutput" :records="records" />
  <table v-else-if="processedRecords.length">
    <colgroup>
      <col class="w-2/3">
      <col class="w-1/3">
    </colgroup>
    <thead>
      <tr class="border-b-2 border-gray-200 text-left">
        <th scope="col" class="py-1.5 font-medium">{{ columnTitle }}</th>
        <th scope="col" class="py-1.5 font-medium">Revalidate in</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(record, index) in processedRecords" :key="index" class="group">
        <td class="py-1">
          <span v-if="isDomain">
            <dns-records-link :domain="record.record.raw" class="text-blue-600 hover:text-blue-800 hover:underline" />
          </span>
          <span v-else>{{ record.record.raw }}</span>
          <CnameChainBadge :chain="record.cnameChain" />
          <copy :content="record.record.raw" class="[visibility:hidden] group-hover:visible" />
        </td>
        <td class="py-1">
          <duration :seconds="record.record.ttl" />
        </td>
      </tr>
    </tbody>
  </table>
  <div v-else>No {{ recordType }} {{ canHaveMultipleRecords ? 'records' : 'record' }} found.</div>
</template>

<script setup lang="ts">
import { computed, PropType } from 'vue';
import { useStore } from 'vuex';
import Copy from '@/components/micro/CopyComponent.vue';
import Duration from '@/components/micro/DurationComponent.vue';
import RawRecords from '@/components/micro/RawRecords.vue';
import CnameChainBadge from '@/components/micro/CnameChainBadge.vue';
import DnsRecordsLink from '@/components/micro/DnsRecordsLink.vue';
import { QueryResult } from '@/model/Api';

const props = defineProps({
  records: {
    type: Object as PropType<QueryResult>,
    required: true,
  },
  columnTitle: {
    type: String,
    required: true,
  },
  recordType: {
    type: String,
    required: true,
  },
  isDomain: {
    type: Boolean,
    default: false,
  },
  canHaveMultipleRecords: {
    type: Boolean,
    default: true,
  },
});

const store = useStore();
const showRawOutput = computed(() => store.state.showRawOutput);

const processedRecords = computed(() => props.records.response.answer.filter((item) => item.record.recordType === props.recordType));
</script>
